import * as React from "react";

import "./adding-form.scss";

import {apiArray}       from "@Common/logic/api-array";
import {bindInput}      from "@Common/react/bind-input";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";

import {addPromoCode} from "./add-promo-code";
import {cx} from "emotion";

export const AddingForm = ({onChange, store, onAdded, onError}) => cs(
    consumeContext("apis"),
    consumeContext("userLevels"),
    ["typing", (_, next) => UseState({next})],
    ["submitting", (_, next) => UseState({next})],
    ({submitting, typing, apis, userLevels}) => (
        <div className="adding-form-3qd">
            <input {...{
                placeholder: "Promo Code",
                ...bindInput({
                    value: typing.value,
                    onChange: (code1) => {
                        typing.onChange(code1);
                        onChange();
                    },
                }),
                disabled: submitting.value,
                "xd-qa-type": "text_field",
                "xd-qa-name": "Promo Code",
            }}/>

            <button
                className={cx({disabled: (submitting.value || !typing.value || userLevels?.isGuest)})}
                onClick={async () => {
                    if(submitting.value || !typing.value) {
                        return;
                    } else if(userLevels?.isGuest) {
                        onError(["Something went wrong. Please refresh the page."]);
                    } else {
                        submitting.onChange(true);
                        onChange();

                        try {
                            const result = await store.dispatch(addPromoCode(typing.value, {apis}));
                            onAdded(apiArray(result.appliedCredits.promoCodes));
                            typing.onChange(null);
                        } catch ({errorMessages, appliedCodes}) {
                            onAdded(appliedCodes);
                            onError(errorMessages);
                        } finally {
                            submitting.onChange(false);
                        }
                    }
                }}
                xd-qa-type="button"
                xd-qa-name="REDEEM"
            >
                REDEEM
            </button>
        </div>
    )
);